/*jshint esversion: 9 */
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';

import moment from 'moment-timezone';
import 'magnific-popup';
import 'slick-carousel';
import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import Vue2Filters from 'vue2-filters';
import VueFilterDateFormat from 'vue-filter-date-format';
import VueTheMask from 'vue-the-mask';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Card, createToken } from 'vue-stripe-elements-plus';
import Slick from "vue-slick";

//Set up validators
extend('required', {
    ...required,
    message: 'This field is required'
});
//Check for an Australian mobile number, passed through vue-the-mask so formatted like '04## ### ###'
extend('ausMobile', {
    validate(value) {
        if (value.length < 12) return false;
        if (value.match(/^04\d{2}\s{1}\d{3}\s{1}\d{3}$/)) return true;
        return false;
    },
    message: "Not a valid Australian mobile phone number"
});

//Cart storage
import store from './stores/CartStore';
console.log(CanningsOrderFormSettings.receiptHtml);
//Attach filters
Vue.use(Vue2Filters);
Vue.use(VueFilterDateFormat);
Vue.use(VueTheMask)
let OrderForm = new Vue({
    el: '#orderform',
    store,
    components: {
        'loading': Loading,
        'card': Card,
        'datepicker': Datepicker,
        'validation-provider': ValidationProvider,
        'validation-observer': ValidationObserver,
        'slick' : Slick,
    },
    data: {

        isLoading: false, //Hide/show loading component
        hasDelivery: false, //Delivery disabled
        isMiniCartOpen: false,

        debug: false,
        reloading: false,
        page: (CanningsOrderFormSettings.receiptHtml == null ? 'form' : 'receipt'), //form|checkout|receipt

        error: '',

        //Fields attached to the form
        fields: CanningsOrderFormSettings.fields,

        //Settings object passed inline
        settings: CanningsOrderFormSettings,

        //Product selected for popup display
        product: null,

        cardComplete: false,
        cardName: '',
        payment: (CanningsOrderFormSettings.isStaff != '' ? 'manual' : 'ccard'), //manual|ccard
        stripe: CanningsOrderFormSettings.stripe,
        manualAmount: CanningsOrderFormSettings.deposit,
        priorityAmount: CanningsOrderFormSettings.deposit_priority,

        //Receipt markup
        receiptHtml: CanningsOrderFormSettings.receiptHtml,

        //Options for the slick slider in the product popup
        productSlickOptions: {
            infinite: true,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="slick-prev"><svg fill="none" version="1.1" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg"><path d="m7.5371 0.089844a1 1 0 0 0-0.68359 0.34766l-5.6953 6.6445a1.0001 1.0001 0 0 0 0 1.3008l5.6953 6.6465a1 1 0 0 0 1.4102 0.10742 1 1 0 0 0 0.10938-1.4102l-5.1387-5.9941 5.1387-5.9941a1 1 0 0 0-0.10938-1.4102 1 1 0 0 0-0.72656-0.23828z" stroke-linecap="round" stroke-linejoin="round" style="-inkscape-stroke:none"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path style="-inkscape-stroke:none" d="M1.307.328a1 1 0 0 0-.108 1.41l5.137 5.994-5.137 5.995a1 1 0 0 0 .108 1.41 1 1 0 0 0 1.41-.108l5.697-6.644a1 1 0 0 0 0-1.303L2.717.438a1 1 0 0 0-1.41-.11z" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            asNavFor: '.popup__gallery-thumbs'
        },

        productSlickThumbsOptions: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            asNavFor: '.popup__gallery-main',
            focusOnSelect: true
        },

        //How to order instructions
        showOrderInstructions: false,
    },
    created: function() {
    },

    mounted: function() {

        //Displaying the receipt - hide elements, apply classes to the website header/footer, etc
        if (this.isReceipt) {

        }

        //Pre-populate the data, to save filling it in all the time
        if ((CanningsOrderFormSettings.debug) && (this.firstname == '')) {
            this.firstname = 'Testy';
            this.lastname = 'Testerson';
            this.email = 'test@pederick.com';
            this.phone = '0411222333';
            this.address = '1 Test Street';
            this.suburb = 'Testville';
            this.postcode = '3000';

            //this.location = 'Hawthorn';
        }

        //Populate the list of seafood product id's
        var seafoodProductIds = [];
        for(var sectionKey in CanningsOrderFormSettings.sections) {
            var section = CanningsOrderFormSettings.sections[sectionKey];
            if (section.slug == 'seafood') {
                for(var productKey in section.products) {
                    seafoodProductIds.push(section.products[productKey].id);
                }
            }
        }
        //Add the extra 'seafood' products (from different sections - manually added server-side)
        if ((typeof(CanningsOrderFormSettings.seafoodExtras) != 'undefined')
            && (Array.isArray(CanningsOrderFormSettings.seafoodExtras))
            && (CanningsOrderFormSettings.seafoodExtras.length > 0)) {
            for(var i=0; i<CanningsOrderFormSettings.seafoodExtras.length; i++)
                seafoodProductIds.push(CanningsOrderFormSettings.seafoodExtras[i]);
        }

        this.$store.commit('setSeafoodProductIds', seafoodProductIds);

        //Set the 'Pickup Only' products
        this.$store.commit('setPickupOnlyProductIds', CanningsOrderFormSettings.pickup_only);

        //Popups
        jQuery('.popup-inline').magnificPopup({
            type: 'inline',
            midClick: true,
        });
    },

    computed: {
        //Ordering is over if not staff, and finish time hit or form inactive
        isFinished: function () {
            var finish = moment.tz(this.settings.finish, 'Australia/Melbourne');
            var result = (
                ((finish.isBefore()) || (this.settings.active !== '1'))
                && (this.isStaff == false)
                );
            console.log(result);
            return result;
        },

        isReceipt: function () {
            return (this.page == 'receipt');
        },

        isForm: function () {
            return (this.page == 'form');
        },

        isPickup: function () {
            return (this.delivery == '');
        },
        isDelivery: function () {

            return (this.delivery != '') && !this.hasPickupOnly && this.hasDeliverySlots;
        },
        amountWithDelivery: function() {
            if(this.isDelivery){

                var finalAmount = parseInt(this.depositAmount) + parseInt(this.settings.deposit_home_delivery);
            }else{
                var finalAmount = this.depositAmount;
            }
            return finalAmount;
        },
        hasDeliverySlots: function() {
            return (Object.keys(this.settings.delivery_dates).length > 0);
        },

        cartCount: function () {
            return this.$store.getters.getSummaryTotal;
        },

        //Get the selected location's address
        locationAddress: function () {
            for (var key in this.settings.locations) {
                var name = this.settings.locations[key];
                if (key == this.location)
                    return name;
            }
            return '';
        },

        //Check if the currently set postcode can be delivered to
        canDeliver: function () {
            if (this.hasDelivery !== true) return false; //Delivery disabled

            if (this.postcode == '') return false;
            for (var key in this.settings.delivery.postcodes) {
                var postcode = this.settings.delivery.postcodes[key];
                for (var i = 0; i < postcode.length; i++) {
                    if (postcode[i] == this.postcode)
                        return true;
                }
            }
            return false;
        },

        //Check if location has been selected
        hasLocation: function() {
            return (this.location != '');
        },

        canSubmitCheckout: async function() {
            return ((this.isPickup && this.hasLocation) || (this.isDelivery && this.delivery != '')) && ((this.isStaff && this.payment == 'manual') || this.cardComplete);
        },

        //Determine the automatically-assigned pickup date
        pickup: function() {

            if (this.location == '') return 'Select a store';

            var slug = this.getSlug(this.location)
            if (this.settings.pickup[slug] == undefined) return 'TBA';

            //If the order has any seafood, it's always the 24th
            if (this.hasSeafood) {
                return this.settings.seafoodPickup;
            } else {
                //Otherwise find the next available slot, that's not the 24th
                for (var date in this.settings.pickup[slug]) {
                    if (date == this.settings.seafoodPickup) continue; //No seafood - can't be the 24th
                    var available = this.settings.pickup[slug][date];
                    if (available > 0)
                        return date;
                }
            }

            return 'Unavailable';
        },

        //Make the pickup date human-friendly
        pickupDate: function() {

            if(this.pickupPriority !== ''){
                var date = moment(this.pickupPriority);
            }else{
                var date = moment(this.pickup);
            }
            
            if (date.isValid() == false)
                return this.pickup;

            return date.format('dddd, MMMM Do YYYY');
        },
        isChristmasEve: function() {
            var date = moment(this.pickup);
            if (date.isValid())
                return ((date.date() == 24) && (date.month()==11));
            return false;
        },
        isAlternateChristmasEve: function() {
            var date = moment(this.pickupPriority);
            if (date.isValid())
                return ((date.date() == 24) && (date.month()==11));
            return false;
        },

        //Set the datepicker open to to the first date available for the selected location
        datepickerOpenDate: {
            get() {
                var now = moment().toDate();
                if (OrderForm.location == '') return now;

                var slug = OrderForm.getSlug(OrderForm.location)
                if (OrderForm.settings.pickup[slug] == undefined) return now;

                for (var pickupDate in OrderForm.settings.pickup[slug]) {
                    return moment(pickupDate).toDate();
                }
            }
        },

        //Set the datepicker disabled date to the dates available for the selected location
        datepickerDisabledDates: {
            get() {
                var self = this;
                return {
                    customPredictor: function (date) {
                        if (OrderForm.location == '') return true;

                        var slug = OrderForm.getSlug(OrderForm.location)
                        if (OrderForm.settings.pickup[slug] == undefined) return true;

                        // Rule removed 2019-10-31: BH45
                        //If the order doesn't have seafood, can't choose the 24th
                        //var seafoodPickup = moment(OrderForm.settings.seafoodPickup);
                        //if ((OrderForm.hasSeafood == false) && (moment(date).isSame(seafoodPickup, 'day')))
                        //    return true;

                        for (var pickupDate in OrderForm.settings.pickup[slug]) {
                            if (moment(date).isSame(moment(pickupDate), 'day')) {
                                return (OrderForm.settings.pickup[slug][pickupDate] <= 0);
                            }
                        }

                        return true;
                    }
                };
            }
        },

        //Set the datepicker disabled date to the dates available for the selected location
        deliveryDisabledDates: {
            get() {
                var self = this;
                return {
                    customPredictor: function (date) {
                        for(var availableDate in OrderForm.settings.delivery_dates) {
                            if (moment(date).isSame(moment(availableDate), 'day')) {
                                return false;
                            }
                        }
                        return true;
                    }
                };
            }
        },
        //Has the user selected or accepted their allocated date?
        usingAllocatedDate: function() {
            if ((this.pickupPriority == '') || (this.pickupAllocated == this.pickupPriority))
                return true;
            if (moment(this.pickupPriority).isBefore(moment(this.pickupAllocated)))
                return true;
            return false;
        },

        deposit: {
            get () {
                return (this.usingAllocatedDate ? parseFloat(this.settings.deposit) : parseFloat(this.settings.deposit) + this.deposit_priority);
            }
        },
        deposit_priority: {
            get () {
                return parseFloat(this.settings.deposit_priority);
            }
        },

        //Map the store fields
        cart: {
            get () { return this.$store.state.cart; },
        },
        hasSeafood: {
            get () { return this.$store.getters.hasSeafood; },
        },
        hasPickupOnly: {
            get () { return this.$store.getters.hasPickupOnly; },
        },
        firstname: {
            get () { return this.$store.state.firstname; },
            set (value) { return this.$store.commit('setFirstname', value); },
        },
        lastname: {
            get () { return this.$store.state.lastname; },
            set (value) { return this.$store.commit('setLastname', value); },
        },
        email: {
            get () { return this.$store.state.email; },
            set (value) { return this.$store.commit('setEmail', value); },
        },
        phone: {
            get () { return this.$store.state.phone; },
            set (value) { return this.$store.commit('setPhone', value); },
        },
        promotion: {
            get () { return this.$store.state.promotion; },
            set (value) { return this.$store.commit('setPromotion', value); },
        },
        address: {
            get () { return this.$store.state.address; },
            set (value) { return this.$store.commit('setAddress', value); },
        },
        suburb: {
            get () { return this.$store.state.suburb; },
            set (value) { return this.$store.commit('setSuburb', value); },
        },
        postcode: {
            get () { return this.$store.state.postcode; },
            set (value) { return this.$store.commit('setPostcode', value); },
        },
        delivery: {
            get () { return this.$store.state.delivery; },
            set (value) { return this.$store.commit('setDelivery', value); },
        },
        pickupAllocated: {
            get () { return this.$store.state.pickupAllocated; },
            set (value) { return this.$store.commit('setPickupAllocated', value); },
        },
        pickupPriority: {
            get () { return this.$store.state.pickupPriority; },
            set (value) { return this.$store.commit('setPickupPriority', value); },
        },
        pickupDateFinal: {
            get () { return (this.$store.state.pickupPriority == '' ? this.$store.state.pickupAllocated : this.$store.state.pickupPriority); },
        },
        depositAmount: {
            get () { return (this.$store.state.deposit == null ? this.deposit : this.$store.state.deposit); },
            set (value) { return this.$store.commit('setDeposit', value); },
        },
        location: {
            get () { return this.$store.state.location; },
            set (value) { return this.$store.commit('setLocation', value); },
        },
        notes: {
            get () { return this.$store.state.notes; },
            set (value) { return this.$store.commit('setNotes', value); },
        },

        getCartPrice: {
            get () { return this.$store.state.getCartPrice; }
        },

        //Is a staff member logged in?
        isStaff: {
            get () {
                return (parseInt(this.settings.isStaff) === 1);
            }
        }
    },

    watch: {
        pickup () {
            this.$store.commit('setPickupAllocated', this.pickup);
        }
    },

    methods: {

        reload: function() {
            this.reloading = true;
            window.location = '/';
        },

        log: function(str) {
            console.log(str);
        },
        
        //Check if a product option should be disabled
        isOptionDisabled: function(productId, option)
        {
            var remaining = this.productsRemaining(productId, option);
            if ((remaining == undefined) || (remaining > 0)) return false;
            return true;
        },

        flagDelivery: function(state) {
            var dates = Object.keys(this.settings.delivery_dates);
            if ((state == true) && (dates.length > 0)) {
                this.delivery = dates[0];
                this.location = 'Delivery';
            } else {
                this.delivery = '';
                this.location = '';
            }
        },

        //Converts a string to a slug
        getSlug: function (str)
        {
            if (typeof(str) != 'string') return str;

            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
            var to   = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

            for (var i=0, l=from.length ; i<l ; i++)
            {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace('.', '-') // replace a dot by a dash
                .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
                .replace(/-+/g, '-') // collapse dashes
                .replace( /\//g, '' ); // collapse all forward-slashes

                return str;
            },

        //Format the datepicker display
            datepickerFormatter: function(date) {
                return moment(date).format('dddd, MMMM Do YYYY');
            },

            productAvailable: function(product) {
                for(var key in product.options) {
                    var option = product.options[key];
                    if (this.productsRemaining(product.id, option) > 0)
                        return true;
                }
                return false;
            },

        //Check how many of the product/option are still available
            productsRemaining: function(productId, option) {
            //Get the quantity from the cart
                var inCart = 0;
                var found = this.$store.getters.getCartItem(productId, option);
                if (found != undefined)
                    inCart = found.qty;

            //Find the limit
                if (this.settings.limits[productId] !== undefined) {
                    if (this.settings.limits[productId][option] !== undefined) {
                        return parseInt(this.settings.limits[productId][option]) - inCart;
                    }
                }

            //No limit
                return undefined;
            },

            reset: function() {
                this.$store.dispatch('reset').then(() => {
                    window.localStorage.removeItem('vuex');
                });
            },

        //Toggle the cart
            minicartOpen: function(e) {
                e.preventDefault();
                this.isMiniCartOpen = !this.isMiniCartOpen;
                jQuery('#overlay').fadeIn();
            },
            minicartClose: function() {
                this.isMiniCartOpen = false;
                jQuery('#overlay').fadeOut();
            },

        //Add to cart
            cartAdd: function(product, e) {

            //Get the selected option
                var option = jQuery(this.$refs['option'+product.id]).val();
                if (option == null) {
                    if (product.options.length > 1)
                    return; //Not a valid option any more (out of stock)
                option = product.options[0];
            }

            //Check there's product left
            var remaining = this.productsRemaining(product.id, option);
            if (remaining <= 0) return;
            console.log(product.fields.form_title);
            //Add to the cart
            this.$store.commit('addToCart', {
                id: product.id,
                option: option,
                title: product.title,
                form_title: product.fields.form_title,
                price: product.price,
                unit: product.unit,
                thumbnail: product.thumbnail_2x,
            });

            //Animate the cart tooltip
            jQuery('.cart-tooltip').remove();

            if ( e.target.classList.contains('popup-btn') ) {
                jQuery('.popup__actions .add').append('<span class="cart-tooltip">Item added</span>');
            } else {
                jQuery('.site-header__cart .view-cart').append('<span class="cart-tooltip">Item added</span>');
            }

            setTimeout(() => {
              jQuery('.cart-tooltip').remove();
          }, 2001);
        },
        //Remove an item from the cart
        cartRemove: function(item) {
            this.$store.commit('removeFromCart', {id: item.id, option: item.option});
        },
        //Check if the item is incrementable
        canIncrement: function(item) {
            if (item == undefined) return false;
            var remaining = this.productsRemaining(item.id, item.option);
            if ((remaining == undefined) || (remaining > 0)) return true;
            return false;
        },
        //Increase a cart item's quantity
        cartIncrement: function(item) {
            if (this.canIncrement(item))
                this.$store.commit('increment', {id: item.id, option: item.option});
        },
        //Decrease a cart item's quantity
        cartDecrement: function(item) {
            this.$store.commit('decrement', {id: item.id, option: item.option});
        },

        //Display a popup with the product details
        productShow: function(product) {
            //Change the product reference
            this.product = product;

            //Update the slick gallery
            this.$nextTick(() => {
                if (OrderForm.$refs.productSlick)
                    OrderForm.$refs.productSlick.reSlick();
            });

            //Show the popup
            jQuery.magnificPopup.open({
                items: {
                    src: '#of-popup-product'
                },
                type: 'inline',
                closeOnContentClick: false
            }, 0);

        },

        //Switch the display between form|checkout|receipt
        go: function(page) {
            jQuery('#overlay').fadeOut();
            
            this.page = page;

            jQuery('html, body').animate({
                scrollTop: 0
            });
        },
        goCategory: function (category, e) {
            e.preventDefault();
            jQuery('#overlay').fadeOut();
            
            if ( this.page != 'form' ) {
                this.page = 'form';
            }

            setTimeout(() => {
                const el = document.querySelector("#product-categories")
                const observer = new IntersectionObserver(
                    ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
                    {
                        rootMargin: '-86px 0px 1000px 0px',
                        threshold: [1]
                    }
                    );
                observer.observe(el);
                
                jQuery('html, body').animate({
                    scrollTop: jQuery('#' + category).offset().top - ( jQuery('.site-header').outerHeight() + (jQuery('#product-categories').outerHeight() * 1.25))
                }, 1000);
            }, 50);
        },
        goCheckout: function(){
            if (this.cart.length <= 0) {
                alert('Please add one or more products to your order');
            } else {
                if (typeof(ga) != 'undefined')
                    ga('send', 'event', 'Button', 'submit', 'Go to checkout');

                this.isMiniCartOpen = false;

                this.go('checkout');
            }
        },
        goForm: function() {
            this.go('form');
        },
        goReceipt: function() {
            this.go('receipt');
        },


        //Submit the order
        submit: async function()
        {
            //Check the validation
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            //Set the 'loading' indicator
            this.isLoading = true;

            if (this.payment == 'ccard') {
                //Create a Stripe token
                createToken({
                    name: this.cardName,
                    address_line1: this.address,
                    address_city: this.suburb,
                    address_zip: this.postcode,
                    address_country: 'Australia'
                }).then(data => {
                    if (data.token) {
                        this.order(data.token.id);
                    } else {
                        if (data.error) {
                            this.error = data.error.message;
                        } else {
                            this.error = 'Unable to submit for order - unknown error';
                        }
                        OrderForm.isLoading = false;
                    }
                });
            } else {
                //Manual payment - just pass a null token
                this.order(null);
            }

            return false;
        },

        //Send the order to the server
        order: function(token)
        {
            //Set up the order items
            var order = {
                isPickup: this.isPickup,
                items: this.cart,
                total: this.getCartPrice
            };

            //Set as pickup or delivery
            if (this.isPickup) {
                order.pickup = {
                    allocated: this.pickupAllocated,
                    selected: this.pickupPriority
                };
            } else {
                order.delivery_date = moment(this.delivery).format('YYYY-MM-DD');
            }
            var self = this;
            jQuery.ajax({
                type: 'POST',
                url: self.settings.ajaxurl,
                dataType: "json",
                data: {action: 'check_finished_date', term_slug: CanningsOrderFormSettings.slug}
                
            }).done(function(data) {
                if(data.success && data.finished_date !== ''){
                    var finish = moment.tz(data.finished_date, 'Australia/Melbourne');
                    
                    if((finish.isBefore(moment()) || (data.is_active !== 1)) && (data.is_staff == false))
                    {

                        window.location.reload();
                        return;
                    }
                    console.log(self);
                    //Post the data
                    jQuery.ajax({
                        type: 'POST',
                        url: self.settings.ajaxurl,
                        data: {
                            action: 'order',
                            form_id: self.settings.slug,
                            order: order,
                            details: {
                                name_first: self.firstname,
                                name_last: self.lastname,
                                address: self.address,
                                suburb: self.suburb,
                                postcode: self.postcode,
                                email: self.email,
                                phone: self.phone,
                                promotion: (self.promotion ? 'Yes' : 'No'),
                                notes: self.notes,
                                location: self.location,
                                payment_type: self.payment,
                                deposit: self.depositAmount,
                                stripe_token: token
                            }
                        },
                        dataType: "json"
                    }).done(function(result) {

                        if (result && result.success)
                        {

                                    // Analytics
                            if (typeof (ga) != 'undefined') {
                                ga('send', {
                                    hitType: 'event',
                                    eventCategory: 'Button',
                                    eventAction: 'Submit',
                                    eventLabel: 'Place Order',
                                    eventValue: result.deposit
                                });
                            }

                                    //Clear the cart
                            OrderForm.reset();

                                    //Store the receipt markup for display
                            OrderForm.receiptHtml = result.receipt;

                                    //Show the receipt
                            OrderForm.goReceipt();
                        }
                        else
                        {

                                    //Notify BugSnag
                            if (typeof('Bugsnag') !== 'undefined')
                                Bugsnag.notify("Submit Error", result.message);

                            OrderForm.error = result.message;

                        }

                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                        console.log(jqXHR);
                                //Notify BugSnag
                        if (typeof('Bugsnag') !== 'undefined')
                            Bugsnag.notify("Submit Error", 'Error while submitting an order: [' + textStatus + ']' + errorThrown);

                        OrderForm.error = 'Unable to contact the server - please try again.';

                    }).always(function() {

                        OrderForm.isLoading = false;

                    });
                    
                }
            })

            
        },

        //When the receipt is displayed
        onReceipt: function() {            

            // Thankyou page redirect
            setTimeout(function () {
                this.reload();
            }, 10000);

            
            //Analytics
            goog_snippet_vars = function () {
                var w = window;
                w.google_conversion_id = 1000698362;
                w.google_conversion_label = "_eURCO_ruGwQ-uOV3QM";
                w.google_remarketing_only = false;
            };              

            // DO NOT CHANGE THE CODE BELOW.
            goog_report_conversion = function (url) {
                goog_snippet_vars();
                window.google_conversion_format = "3";
                var opt = new Object();
                opt.onload_callback = function () {
                    if (typeof (url) != 'undefined') {
                        window.location = url;
                    }
                }
                var conv_handler = window['google_trackConversion'];
                if (typeof (conv_handler) == 'function') {
                    conv_handler(opt);
                }
            };

        }

    }
}).$mount('#orderform');
